import { t } from "@/i18n-js/instance";
import { ExecutePreviewCard } from "./ExecutePreviewCard";

export interface TagExecutePreviewProps {
  is_public?: boolean;
  name?: string;
}

export const TagExecutePreview = ({
  name,
  is_public,
}: TagExecutePreviewProps) => {
  let publicText: string | undefined;
  if (is_public !== undefined) {
    publicText = is_public
      ? t("help_widget.copilot.execute_preview.yes")
      : t("help_widget.copilot.execute_preview.no");
  }

  return (
    <ExecutePreviewCard
      title={t("help_widget.copilot.execute_preview.tag_title")}
      attributes={[
        {
          label: t("help_widget.copilot.execute_preview.name"),
          value: name,
        },
        {
          label: t("help_widget.copilot.execute_preview.public"),
          value: publicText,
        },
      ]}
    />
  );
};
